import React, {Component} from "react";
import connect from "react-redux/es/connect/connect";
import {Button, Card, CardBody, CardTitle, Col, Label, Row} from "reactstrap";
import axios from "axios";
import Alerts from "../../util/Alerts";
import BlkFormik from "../../util/BlkFormik";
import {Form} from "formik";
import {find_aseguradoras, find_companias, find_ram_grupos, find_ramos, find_ramos_ramgrp} from "../../api/CacheApi";
import {BlkCalendario} from "../../coms/BlkCalendario";
import ReactTable from "react-table";
import {on_select} from "../polizas/actions";
import {BlkField} from "../../coms/BlkField";
import {routes} from "../General";
import {has_role, pos} from "../../util/General";
import {DetallesVAM} from "./DetallesVAM";
import moment from "moment";
import "moment/locale/es";
import {DeduciblesModal} from "coms/siniestros/DeduciblesModal";
import {ComboCliente} from "../ComboCliente";
import {BlkCheckBox} from "../../coms/BlkCheckBox";
import {Link} from "react-router-dom";
import logo_doc from "../../assets/img/icon/docs.png";
import {NombreTitular} from "../../coms/BlkGenerales";
import {CellMoney} from "../../components/CellMoney";
import {AccidentsExportButton} from "../../components/AccidentsExportButton";

class SiniestrosVAM extends Component {
    constructor(props) {
        super(...arguments);
        this.alert = React.createRef();
        this.form = React.createRef();
        this.state = {
            data: [],
            ramos: [],
            nombres: null,
            telfs: null,
            correos: null,
            companias: [],
            asegs: [],
            pages: -1,
            page: 0,
            loading: false,
            item: {},
            cot: {},
            modalSiniestroVidas: false,
            busquedaAvanzada: false,
            modalDocs: false,
            tipo: "siniestro",
            query: this.itemQuery(),
        };
    }

    itemQuery() {
        return {
            page: 0,
            pageSize: 10,
            poliza: "",
            cdRamo: 0,
            cdAseguradora: 0,
            numSiniestro: "",
            anio: "",
            cdCompania: 1,
            cdCliente: this.props.user.cdCliente,
            inclEjecutivo: false,
            dscObjeto: null,
            titular: null,
            cdEjecutivoAdm: this.props.user.cdEjecutivoAdm || 0,
            cdEjecutivo: this.props.user.cdEjecutivo || 0,
            ci: this.props.user.cedula,
            fcDesde: new Date(new Date().getFullYear() - 1, new Date().getMonth(), 1),
            fcHasta: new Date(),
            sorted: [],
            filtered: [],
            cdPool: this.props.user.cdPool,
        };
    }

    componentDidMount() {
        find_ramos().then(resp => {
            let ramos = resp;
            find_ram_grupos().then(resp => {
                let areas = resp;
                find_ramos_ramgrp().then(resp => {
                    let ramosTmp = [];
                    resp.forEach(r => {
                        let item = Object.assign({}, r); //clono el item
                        item.nmRamo = ramos.find(ramo => ramo.cdRamo === item.cdRamo).nmRamo;
                        item.nmArea = areas.find(area => area.cdRamGrupo === item.cdRamGrupo).nmRamGrupo;
                        item.nm = item.nmRamo;
                        if (this.isVam(item) && this.filterExcluidos(item)) {
                            ramosTmp.push(item);
                        }
                    });
                    this.setState({ ramos: ramosTmp.sort((a, b) => a.nmRamo.localeCompare(b.nmRamo)) });
                });
            });
        });

        find_aseguradoras().then(resp => {
            this.setState({ asegs: resp });
        });
        find_companias().then(resp => {
            this.setState({ companias: resp });
        });
    }

    filterExcluidos(item) {
        if (item.nm.toUpperCase().indexOf("ASISTENCIA MEDICA INDIVIDUAL") >= 0) {
            return false;
        }
        if (item.nm.toUpperCase().indexOf("VIDA CRECIENTE (INDIVIDUAL)") >= 0) {
            return false;
        }
        if (item.nm.toUpperCase().indexOf("VIDA UNIVERSAL INDIVIDUAL") >= 0) {
            return false;
        }
        if (item.nm.toUpperCase().indexOf("VIDA TERMINO INDIVIDUAL") >= 0) {
            return false;
        }
        return true;
    }

    /**
     * funcion a ejecutarse cuando se da click en guardar desde el menu
     */
    onSubmit = (newValues, { setSubmitting }) => {
        this.setState(
            {
                query: { ...this.state.query, ...newValues, page: 0 },
                page: 0,
            },
            () => this.fetchData({}, null, setSubmitting)
        );
    };

    fetchData = (query = {}, _table, setSubmitting) => {
        const filtered = query.filtered ?? [];
        const sorted = query.sorted ?? [];
        if (has_role(this.props.user, "ROLE_ADMIN") || this.state.query.cdCliente) {
            let query2 = Object.assign({}, this.state.query);
            if (query.page >= 0) {
                query2.page = query.page;
                // query2.page = 1;
            }

            if (query.pageSize >= 0) {
                query2.pageSize = query.pageSize;
            }

            if (query2.page !== this.state.query.page || query2.page === 0) {
                this.setState({loading: true});
                axios
                    .post(routes.api + "/siniestros-vam/search", {...query2, sorted, filtered})
                    .then(resp => {
                        this.setState(prev => ({
                            data: resp.data.content,
                            pages: resp.data.totalPages,
                            loading: false,
                            query: {...prev.query, sorted, filtered},
                        }));
                    })
                    .catch(this.alert.current.handle_error)
                    .finally(() => {
                        setSubmitting?.(false);
                        this.setState({loading: false});
                    });
            }
        }
    };

    onSelectCoti = coti => {
        this.setState({ item: coti });
        this.showSiniestroVidas(true);
        this.props.on_select({ cot: coti, query: this.state.query });
    };

    verDocDigital = coti => {
        this.setState({ item: coti }, () => {
            this.showDocs(true);
            this.showSiniestroVidas(false);
        });
    };

    showSiniestroVidas = open => {
        this.setState({ modalSiniestroVidas: open });
    };

    showDocs = open => {
        this.setState({ modalDocs: open });
    };

    isVam = r => {
        let vam = false;
        let ls_nm_grp_ramo = r.nmArea;

        if (pos(ls_nm_grp_ramo, "MEDICA") > 0) {
            //pb_actvam.TriggerEvent(Clicked!)
            vam = true;
        } else if (pos(ls_nm_grp_ramo, "VIDA") > 0) {
            //pb_actvam.TriggerEvent(Clicked!)
            vam = true;
        } else {
            vam = false;
        }
        return vam;
    };
    closeModalDoc = () => {
        this.setState({ modalDocs: false });
    };
    handleResetForm = resetForm => {
        this.setState({ ...this.state, query: this.itemQuery(), data: [], data1: [], selected: -1 });
        resetForm();
    };
    showBusquedaAvanzada = open => {
        this.setState({ busquedaAvanzada: open });
    };

    render() {
        return (
            <div className="content ">
                <Alerts ref={this.alert} />
                <Card>
                    <CardBody>
                        <CardTitle tag="h4">Siniestro Asistencia Médica</CardTitle>
                        <div className="container-fluid container-md">
                            <BlkFormik
                                initialValues={this.state.query}
                                onSubmit={this.onSubmit}
                                ref={this.form}
                                enableReinitialize={true}
                                validateOnChange={false}
                            >
                                {({ resetForm, submitForm, setFieldValue, values }) => (
                                    <Form>
                                        <Row>
                                            {(has_role(this.props.user, "ROLE_ADMIN") ||
                                                has_role(this.props.user, "ROLE_BROKER")) && (
                                                <div className="form-group col-lg-6">
                                                    <ComboCliente
                                                        setFieldValue={setFieldValue}
                                                        name={"cdCliente"}
                                                        alert={this.alert}
                                                        values={values}
                                                    />
                                                </div>
                                            )}
                                            {has_role(this.props.user, "ROLE_EJECUTIVO") && (
                                                <Col xs={2} className={"d-flex  align-items-center"}>
                                                    <Label className={"mr-2"}>Ejecutivo</Label>
                                                    <BlkField
                                                        component={BlkCheckBox}
                                                        styleInput={{ marginLeft: 0, marginTop: "-10px" }}
                                                        name={"inclEjecutivo"}
                                                    />
                                                </Col>
                                            )}
                                            {(has_role(this.props.user, "ROLE_ADMIN") ||
                                                has_role(this.props.user, "ROLE_BROKER")) &&
                                                !this.state.busquedaAvanzada && (
                                                    <div className="form-group col-lg-6">
                                                        <div className="m-1">
                                                            <Button
                                                                type="button"
                                                                color="primary"
                                                                className="my-xl-4"
                                                                onClick={() => {
                                                                    document
                                                                        .getElementById("siniestroVam")
                                                                        .scrollIntoView({ behavior: "smooth" });
                                                                    submitForm();
                                                                }}
                                                            >
                                                                Buscar
                                                            </Button>
                                                        </div>
                                                    </div>
                                                )}
                                        </Row>
                                        <Row>
                                            <div className="form-group col-lg-6">
                                                <Button
                                                    color="primary"
                                                    className="btn my-md-4"
                                                    onClick={() => {
                                                        this.showBusquedaAvanzada(!this.state.busquedaAvanzada);
                                                    }}
                                                >
                                                    Búsqueda Avanzada
                                                </Button>
                                            </div>
                                        </Row>
                                        {this.state.busquedaAvanzada && (
                                            <>
                                                <Row>
                                                    <div className="form-group col-lg-6">
                                                        <Label>Póliza: </Label>
                                                        <BlkField
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="Póliza"
                                                            name="poliza"
                                                        />
                                                    </div>
                                                    <div className="form-group col-lg-6">
                                                        <Label>Aseguradora: </Label>
                                                        <BlkField
                                                            component="select"
                                                            className="form-control w-100 inputTable"
                                                            name="cdAseguradora"
                                                        >
                                                            <option value="0">--TODOS--</option>
                                                            {this.state.asegs.map(aseg => (
                                                                <option
                                                                    key={aseg.cdAseguradora}
                                                                    value={aseg.cdAseguradora}
                                                                >
                                                                    {aseg.nmAlias}
                                                                </option>
                                                            ))}
                                                        </BlkField>
                                                    </div>

                                                    <div className="form-group col-lg-6">
                                                        <Label>Ramo: </Label>
                                                        <BlkField
                                                            component="select"
                                                            className="form-control w-100 inputTable"
                                                            name="cdRamo"
                                                        >
                                                            <option value="0">--TODOS--</option>
                                                            {this.state.ramos.map(ramo => (
                                                                <option key={ramo.cdRamo} value={ramo.cdRamo}>
                                                                    {ramo.nmRamo}
                                                                </option>
                                                            ))}
                                                        </BlkField>
                                                    </div>
                                                    <Col xs={12} lg={6}>
                                                        <Row>
                                                            <div className="form-group col-sm-6">
                                                                <Label>No. Siniestro: </Label>
                                                                <BlkField
                                                                    name="numSiniestro"
                                                                    className="form-control"
                                                                    type="text"
                                                                    placeholder="No. Siniestro"
                                                                />
                                                            </div>
                                                            <div className="form-group col-sm-6">
                                                                <Label>Año Siniestro: </Label>
                                                                <BlkField
                                                                    name="anio"
                                                                    className="form-control"
                                                                    type="text"
                                                                    placeholder="Año Siniestro"
                                                                />
                                                            </div>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                <div className="row">
                                                    <div className="form-group col-lg-6 m-0">
                                                        <small className="m-0 text-primary">
                                                            Fecha de Ocurriencia del Siniestro
                                                        </small>
                                                    </div>
                                                </div>
                                                <Row>
                                                    <Col xs={12} lg={6}>
                                                        <Row>
                                                            <div className="form-group col-sm-6">
                                                                <Label>Desde: </Label>
                                                                <BlkField
                                                                    name="fcDesde"
                                                                    placeholder="Ingrese Fecha"
                                                                    component={BlkCalendario}
                                                                />
                                                            </div>
                                                            <div className="form-group col-sm-6">
                                                                <Label>Hasta: </Label>
                                                                <BlkField
                                                                    name="fcHasta"
                                                                    placeholder="Ingrese Fecha"
                                                                    component={BlkCalendario}
                                                                />
                                                            </div>
                                                        </Row>
                                                    </Col>
                                                    {has_role(this.props.user, "ROLE_EJECUTIVO") && (
                                                        <Col xs={12} lg={6}>
                                                            <Row>
                                                                <div className="form-group col">
                                                                    <Label>Titular: </Label>
                                                                    <BlkField
                                                                        name="titular"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Titular"
                                                                    />
                                                                </div>
                                                            </Row>
                                                        </Col>
                                                    )}
                                                </Row>
                                                <br />
                                                <Row>
                                                    <div className="form-group col-md-6">
                                                        <Button
                                                            type="button"
                                                            color="primary"
                                                            className="mb-3 mr-2"
                                                            onClick={() => {
                                                                document
                                                                    .getElementById("siniestroVam")
                                                                    .scrollIntoView({ behavior: "smooth" });
                                                                submitForm();
                                                            }}
                                                        >
                                                            Buscar
                                                        </Button>
                                                        <Button
                                                            color="yellow"
                                                            className="mb-3 mr-2"
                                                            onClick={() => this.handleResetForm(resetForm)}
                                                        >
                                                            Nueva Consulta
                                                        </Button>
                                                    </div>
                                                </Row>
                                            </>
                                        )}
                                        <Row>
                                            <div className="form-group col-md-6" />
                                            {values.cdCliente && (
                                                <Col
                                                    md={6}
                                                    className={
                                                        "d-flex flex-wrap justify-content-center justify-content-md-end"
                                                    }
                                                >
                                                    <div className="form-group">
                                                        <Link
                                                            to={`/gen/docs-am/${values.cdCliente}?icon=true`}
                                                            className="btn btn-outline-primary"
                                                        >
                                                            <img className={"st-20"} src={logo_doc} />
                                                            <span className={"ml-2"}>Nuevo Siniestro</span>
                                                        </Link>
                                                    </div>
                                                    <div className="form-group ml-2">
                                                        <Link
                                                            to={`/gen/docs-cred-hosp/${values.cdCliente}?icon=true`}
                                                            className="btn btn-outline-primary"
                                                        >
                                                            <img
                                                                className={"st-20"}
                                                                src={logo_doc}
                                                                alt={"Crédito Hospitalario"}
                                                            />
                                                            <span className={"ml-2"}>
                                                                Solicitar Crédito Hospitalario
                                                            </span>
                                                        </Link>
                                                    </div>
                                                    <div
                                                        className={
                                                            "col-md-6x d-flex flex-wrap justify-content-center justify-content-md-end"
                                                        }
                                                    >
                                                        <small className="d-flex align-items-center m-2">
                                                            <i
                                                                className="fas fa-circle mr-2"
                                                                style={{ color: "yellow" }}
                                                            />
                                                            <Label> Pendiente de Respuesta</Label>
                                                        </small>
                                                        <small className="d-flex align-items-center m-2 ">
                                                            <i
                                                                className="fas fa-circle mr-2"
                                                                style={{ color: "red" }}
                                                            />
                                                            <Label> Nota de Cobranza Pendiente Cliente</Label>
                                                        </small>
                                                        <small className="d-flex align-items-center m-2">
                                                            <i
                                                                className="fas fa-circle mr-2"
                                                                style={{ color: "#495057" }}
                                                            />
                                                            <Label>Liquidado</Label>
                                                        </small>
                                                    </div>
                                                </Col>
                                            )}
                                        </Row>
                                        <div className="d-flex justify-content-end mt-3">
                                            <AccidentsExportButton
                                                isDisabled={!values.cdCliente}
                                                title={
                                                    !values.cdCliente &&
                                                    "Debe seleccionar un Cliente para habilitar la descarga"
                                                }
                                                fileName={"siniestros-asistencia-medica.xlsx"}
                                                url={routes.api + "/siniestros-vam/export"}
                                                payloadSearch={{
                                                    ...values,
                                                    cdPool: values.cdPool || null,
                                                    dscObjeto: values.dscObjeto || null,
                                                    titular: values.titular || null,
                                                    sorted: this.state.query.sorted,
                                                    filtered: this.state.query.filtered,
                                                }}
                                            />
                                        </div>
                                    </Form>
                                )}
                            </BlkFormik>
                            <br/>
                            <Label>Siniestros VAM: </Label>
                            <div id={"siniestroVam"} />
                            <Row>
                                <Col xs={12}>
                                    <ReactTable
                                        loadingText={"Cargando..."}
                                        noDataText={"No se ha encontrado información"}
                                        previousText={"Anterior"}
                                        nextText={"Siguiente"}
                                        pageText={"Página"}
                                        rowsText={"filas"}
                                        ofText={"de"}
                                        columns={[
                                            {
                                                Header: "Titular",
                                                minResizeWidth: 100,
                                                width: 300,
                                                accessor: "titular",
                                                Cell: row => <NombreTitular row={row.original} />,
                                            },
                                            {
                                                Header: "Paciente",
                                                minResizeWidth: 10,
                                                width: 300,
                                                accessor: "dscObjeto",
                                            },
                                            {
                                                Header: "Incapacidad",
                                                minResizeWidth: 10,
                                                width: 200,
                                                accessor: "nmIncapacidad",
                                            },
                                            {
                                                Header: "Valor incurrido",
                                                minResizeWidth: 10,
                                                accessor: "valIncurrido",
                                                Cell: CellMoney,
                                            },
                                            {
                                                Header: "Valor liquidado",
                                                minResizeWidth: 10,
                                                accessor: "valorLiquidado",
                                                Cell: CellMoney,
                                            },
                                            {
                                                Header: "Deducible aplicado",
                                                minResizeWidth: 10,
                                                accessor: "deducibleAplicado",
                                                Cell: CellMoney,
                                            },
                                            {
                                                Header: "Observaciones",
                                                minResizeWidth: 50,
                                                minWidth: 250,
                                                accessor: "observaciones",
                                            },
                                            {
                                                id: "fcSiniestro",
                                                Header: "Fc Siniestro",
                                                accessor: d => {
                                                    return moment(d.fcSiniestro)
                                                        .locale("moment/locale/es")
                                                        .local()
                                                        .format("DD/MM/YYYY");
                                                },
                                                minResizeWidth: 10,
                                            },
                                            {
                                                Header: "Aseguradora",
                                                minResizeWidth: 10,
                                                width: 200,
                                                accessor: "nmAseg",
                                            },
                                            {
                                                Header: "Póliza",
                                                minResizeWidth: 10,
                                                accessor: "poliza",
                                            },
                                            {
                                                Header: "No. Siniestro",
                                                minResizeWidth: 10,
                                                accessor: "numSiniestro",
                                            },
                                        ]}
                                        getTdProps={(state, rowInfo, column) => {
                                            if (rowInfo && rowInfo.row) {
                                                return {
                                                    onClick: (e, handleOriginal) => {
                                                        if (column.Header !== "Documentos") {
                                                            this.onSelectCoti(rowInfo.original);
                                                            this.setState({
                                                                selected: rowInfo.index,
                                                                item: rowInfo.original,
                                                            });
                                                        }
                                                        if (handleOriginal) {
                                                            handleOriginal();
                                                        }
                                                    },
                                                    style: {
                                                        cursor: "pointer",
                                                        height: 35,
                                                        color:
                                                            rowInfo.index === this.state.selected ? "white" : "black",
                                                    },
                                                    className:
                                                        rowInfo.index === this.state.selected ? "bg-primary" : "white",
                                                };
                                            } else {
                                                return {};
                                            }
                                        }}
                                        manual
                                        sortable={false}
                                        data={this.state.data}
                                        pages={this.state.pages}
                                        loading={this.state.loading}
                                        onFetchData={this.fetchData}
                                        defaultPageSize={10}
                                        className="-striped -highlight"
                                        page={this.state.page}
                                        pageSize={this.state.pageSize}
                                        onPageChange={page => this.setState({ page, selected: false })}
                                        onPageSizeChange={(pageSize, page) => this.setState({ page, pageSize })}
                                    />
                                </Col>
                            </Row>
                            <br />
                            <br />
                        </div>
                    </CardBody>
                </Card>

                <DetallesVAM
                    open={this.state.modalSiniestroVidas}
                    toggleModal={this.showSiniestroVidas}
                    siniestro={this.state.item}
                    user={this.props.user}
                />

                <DeduciblesModal
                    open={this.state.modalDed}
                    toggleModal={() => this.setState({ modalDed: false })}
                    cedula={this.props.user.cedula}
                    base={routes.apiVam}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user,
    auth: state.auth,
});

const mapDispatchToProps = {
    on_select,
};
export default connect(mapStateToProps, mapDispatchToProps)(SiniestrosVAM);
